import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@fgb/core';
import { TermsAndConditionsType } from '@fgb/core';
import { Subject } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import * as i3 from '@fgb/portal-component-library/src/lib/pipes';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import * as i4 from '@ngx-translate/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

class TermsAndConditionsComponent {
    constructor(termsAndConditionsService, memberQuery) {
        this.termsAndConditionsService = termsAndConditionsService;
        this.memberQuery = memberQuery;
        this.type = TermsAndConditionsType.General;
        this._isDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.memberQuery.userContext$
            .pipe(takeUntil(this._isDestroyed$), switchMap((member) => {
            return this.termsAndConditionsService.getTermsAndConditions(this.type, member?.lcid, member?.clubId);
        }))
            .subscribe((terms) => {
            this.termsAndConditions = terms[0];
        });
    }
    ngOnDestroy() {
        this._isDestroyed$.next();
        this._isDestroyed$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TermsAndConditionsComponent, deps: [{ token: i1.TermsAndConditionsService }, { token: i1.MemberQuery }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TermsAndConditionsComponent, selector: "fgbcl-terms-and-conditions", inputs: { type: "type", defaultTerms: "defaultTerms" }, ngImport: i0, template: "<div class=\"terms-section-box rounded px-4 py-3\">\r\n  <div\r\n    *ngIf=\"termsAndConditions; else defaultTemplate\"\r\n    class=\"terms-section-content text-start mb-3\"\r\n    [innerHtml]=\"termsAndConditions.BodyText | safeHtml\"\r\n  ></div>\r\n  <ng-template #defaultTemplate>\r\n    <ng-container [ngTemplateOutlet]=\"defaultTerms\"></ng-container>\r\n    <ng-container *ngIf=\"!defaultTerms\"> {{ 'terms.default' | translate }}</ng-container>\r\n  </ng-template>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i3.SafeHtmlPipe, name: "safeHtml" }, { kind: "pipe", type: i4.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TermsAndConditionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-terms-and-conditions', template: "<div class=\"terms-section-box rounded px-4 py-3\">\r\n  <div\r\n    *ngIf=\"termsAndConditions; else defaultTemplate\"\r\n    class=\"terms-section-content text-start mb-3\"\r\n    [innerHtml]=\"termsAndConditions.BodyText | safeHtml\"\r\n  ></div>\r\n  <ng-template #defaultTemplate>\r\n    <ng-container [ngTemplateOutlet]=\"defaultTerms\"></ng-container>\r\n    <ng-container *ngIf=\"!defaultTerms\"> {{ 'terms.default' | translate }}</ng-container>\r\n  </ng-template>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1.TermsAndConditionsService }, { type: i1.MemberQuery }], propDecorators: { type: [{
                type: Input
            }], defaultTerms: [{
                type: Input
            }] } });

class TermsAndConditionsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TermsAndConditionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TermsAndConditionsModule, declarations: [TermsAndConditionsComponent], imports: [CommonModule,
            PipesModule,
            FGBSharedModule], exports: [TermsAndConditionsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TermsAndConditionsModule, imports: [CommonModule,
            PipesModule,
            FGBSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TermsAndConditionsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TermsAndConditionsComponent
                    ],
                    imports: [
                        CommonModule,
                        PipesModule,
                        FGBSharedModule
                    ],
                    exports: [
                        TermsAndConditionsComponent
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TermsAndConditionsComponent, TermsAndConditionsModule };
